import type { SVGProps } from 'react';
const SvgEmojiFlags = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#emoji_flags_svg__a)">
      <path
        fill="currentColor"
        d="m14 9-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6Zm4 8h-4l-1-2H7V9h5l1 2h5v6Z"
      />
    </g>
    <defs>
      <clipPath id="emoji_flags_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEmojiFlags;
